import { axios } from '@Root/API'

export const approveContactUpdate = (id, data) => {
  return axios.post(`cognito-contact-updates/${id}/approve`, data)
}
